/**
 * Hero Banner Slider Functionality
 * Matches the design and functionality from the original index.html
 */

const heroBannerInstances = {};

function initHeroBanner(sectionId, options = {}) {
  const defaultOptions = {
    autoPlay: true,
    autoPlayInterval: 5000,
    pauseOnHover: true
  };

  const config = { ...defaultOptions, ...options };
  const heroSection = document.getElementById(`HeroBanner-${sectionId}`);
  
  if (!heroSection) return;

  const slides = heroSection.querySelectorAll('.hero-slide');
  const indicators = heroSection.querySelectorAll('.hero-indicator');
  
  if (slides.length === 0) return;

  let currentSlide = 0;
  let autoPlayInterval = null;

  // Start auto-play if enabled
  if (config.autoPlay && slides.length > 1) {
    startAutoPlay();
  }

  // Pause auto-play on hover if enabled
  if (config.pauseOnHover && config.autoPlay) {
    heroSection.addEventListener('mouseenter', () => {
      clearInterval(autoPlayInterval);
    });

    heroSection.addEventListener('mouseleave', () => {
      if (config.autoPlay) {
        startAutoPlay();
      }
    });
  }

  function showSlide(index) {
    // Remove active class from all slides and indicators
    slides.forEach(slide => slide.classList.remove('active'));
    indicators.forEach(indicator => indicator.classList.remove('active'));

    // Add active class to current slide and indicator
    if (slides[index]) {
      slides[index].classList.add('active');
    }
    if (indicators[index]) {
      indicators[index].classList.add('active');
    }

    currentSlide = index;
  }

  function changeSlide(direction) {
    let newIndex = currentSlide + direction;

    if (newIndex < 0) {
      newIndex = slides.length - 1;
    } else if (newIndex >= slides.length) {
      newIndex = 0;
    }

    showSlide(newIndex);
    resetAutoPlay();
  }

  function goToSlide(index) {
    if (index >= 0 && index < slides.length) {
      showSlide(index);
      resetAutoPlay();
    }
  }

  // Initialize first slide
  showSlide(0);

  // Use event delegation for more reliable event handling
  heroSection.addEventListener('click', function(e) {
    const target = e.target.closest('.hero-nav.prev, .hero-nav.next, .hero-indicator');
    if (!target) return;
    
    e.preventDefault();
    e.stopPropagation();
    
    if (target.classList.contains('hero-nav')) {
      if (target.classList.contains('prev')) {
        changeSlide(-1);
      } else if (target.classList.contains('next')) {
        changeSlide(1);
      }
    } else if (target.classList.contains('hero-indicator')) {
      const indicatorIndex = Array.from(indicators).indexOf(target);
      if (indicatorIndex !== -1) {
        goToSlide(indicatorIndex);
      }
    }
  });

  function startAutoPlay() {
    clearInterval(autoPlayInterval);
    if (config.autoPlay && slides.length > 1) {
      autoPlayInterval = setInterval(() => {
        changeSlide(1);
      }, config.autoPlayInterval);
    }
  }

  function resetAutoPlay() {
    clearInterval(autoPlayInterval);
    if (config.autoPlay && slides.length > 1) {
      startAutoPlay();
    }
  }

  // Store functions in global scope for onclick handlers
  heroBannerInstances[sectionId] = {
    changeSlide: (direction) => {
      changeSlide(direction);
    },
    goToSlide: (index) => {
      goToSlide(index);
    }
  };
}

// Global functions for onclick handlers
function heroBannerChangeSlide(sectionId, direction) {
  if (heroBannerInstances[sectionId]) {
    heroBannerInstances[sectionId].changeSlide(direction);
  }
}

function heroBannerGoToSlide(sectionId, index) {
  if (heroBannerInstances[sectionId]) {
    heroBannerInstances[sectionId].goToSlide(index);
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    // Auto-initialize any hero banners that are already in the DOM
    const heroBanners = document.querySelectorAll('[id^="HeroBanner-"]');
    heroBanners.forEach(banner => {
      const sectionId = banner.id.replace('HeroBanner-', '');
      // Only initialize if not already initialized
      if (!heroBannerInstances[sectionId]) {
        initHeroBanner(sectionId, {
          autoPlay: true,
          autoPlayInterval: 5000,
          pauseOnHover: true
        });
      }
    });
  });
} else {
  // DOM is already ready
  const heroBanners = document.querySelectorAll('[id^="HeroBanner-"]');
  heroBanners.forEach(banner => {
    const sectionId = banner.id.replace('HeroBanner-', '');
    if (!heroBannerInstances[sectionId]) {
      initHeroBanner(sectionId, {
        autoPlay: true,
        autoPlayInterval: 5000,
        pauseOnHover: true
      });
    }
  });
}

